import React from 'react';
import { motion } from 'framer-motion';
import { Lock, ShieldCheck, Zap } from 'lucide-react';
import { GamerButton } from './ui/GamerButton';
export function CTASection() {
  return <section className="py-24 px-4 bg-gamer-dark relative overflow-hidden" data-id="element-11">
      {/* Background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full h-full max-w-4xl bg-gamer-red/5 blur-[100px] pointer-events-none" data-id="element-12"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-13">
        {/* Differentiation */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16 space-y-4 text-xl md:text-2xl font-inter text-gray-400" data-id="element-14">
          <p data-id="element-15">No necesitás mejor skin.</p>
          <p data-id="element-16">No necesitás mejor celular.</p>
          <p className="text-white font-bold text-2xl md:text-3xl mt-4" data-id="element-17">
            Necesitás <span className="text-gamer-red" data-id="element-18">mejor sistema.</span>
          </p>
        </motion.div>

        {/* Final CTA Card */}
        <div className="bg-gamer-card border border-white/10 rounded-2xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-19">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-gamer-red via-gamer-yellow to-gamer-red" data-id="element-20"></div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} data-id="element-21">
            <h2 className="text-3xl md:text-4xl font-orbitron font-bold text-white mb-8 leading-tight" data-id="element-22">
              La diferencia entre seguir perdiendo
              <br data-id="element-23" />
              y empezar a dominar…
              <br data-id="element-24" />
              <span className="text-gamer-yellow" data-id="element-25">es una decisión.</span>
            </h2>

            {/* Pricing */}
            <div className="mb-8" data-id="element-26">
              <div className="flex items-center justify-center gap-4 mb-2" data-id="element-27">
                <span className="text-gray-500 line-through text-xl md:text-2xl font-inter" data-id="element-28">
                  $27 USD
                </span>
                <span className="text-white font-orbitron font-black text-4xl md:text-5xl" data-id="element-29">
                  $9{' '}
                  <span className="text-xl md:text-2xl text-gray-400 font-inter font-normal" data-id="element-30">
                    USD
                  </span>
                </span>
              </div>
              <p className="text-gamer-red font-bold text-base font-inter" data-id="element-31">
                67% de descuento — Solo por hoy
              </p>
            </div>

            <div className="flex flex-col items-center gap-6" data-id="element-32">
              <GamerButton href="https://juegospro369.online/cart/52665779487087:1" className="w-full md:w-auto text-xl md:text-2xl py-6 px-12 shadow-[0_0_30px_rgba(255,26,26,0.4)] animate-pulse-slow" data-id="element-33">
                ACCEDER AHORA Y EMPEZAR A GANAR
              </GamerButton>

              <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8 text-sm text-gray-400 mt-4" data-id="element-34">
                <div className="flex items-center gap-2" data-id="element-35">
                  <Zap className="w-4 h-4 text-gamer-yellow" data-id="element-36" />
                  <span data-id="element-37">Acceso inmediato</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-38">
                  <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-39" />
                  <span data-id="element-40">Producto 100% digital</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-41">
                  <Lock className="w-4 h-4 text-blue-400" data-id="element-42" />
                  <span data-id="element-43">Pago seguro</span>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-white/5" data-id="element-44">
              <p className="text-gamer-yellow font-bold font-orbitron tracking-widest animate-pulse" data-id="element-45">
                EMPIEZA HOY. MEJORA ESTA SEMANA.
              </p>
            </div>
          </motion.div>
        </div>

        <footer className="mt-16 text-gray-600 text-sm" data-id="element-46">
          <p data-id="element-47">© 2024 Dominio Total Free Fire. Todos los derechos reservados.</p>
          <p className="mt-2" data-id="element-48">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera.
          </p>
        </footer>
      </div>
    </section>;
}